import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'packingWeekDate',
  pure: true,
})
export class PackingWeekDatePipe extends DatePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (!value) {
      return value;
    }
    const date = this.packingWeekDate(value);
    return super.transform(date, args);
  }

  private packingWeekDate(packingWeek: string): Date {
    let year: number = new Date().getFullYear();
    let weekStr = packingWeek;

    // we accept both YYYY-Www and Www formats.
    if (packingWeek.length !== 3) {
      const parts = packingWeek.split('-');
      year = parseInt(parts[0], 10);
      weekStr = parts[1];
    }

    const week = parseInt(weekStr.slice(1), 10);

    // assume ISO8601 week
    // taken from https://stackoverflow.com/a/16591175
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dow = simple.getDay();
    const ISOweekStart = simple;
    if (dow <= 4) {
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    } else {
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    }
    return ISOweekStart;
  }
}
